import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'upgrade-cmp',
	moduleId: module.id,
	templateUrl: 'upgrade.component.html'
})
export class UpgradeComponent implements OnInit {
	ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/upgrade/upgrade.component.ts